/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import DraftsWrapper from './components/Wrapper.vue';
import DraftsIndexView from './components/Index.vue';
import ScheduledIndexView from './components/ScheduledIndex.vue';
import DraftsComposeView from './components/Compose.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/drafts'),
    component: DraftsWrapper,
    children: [
      {
        path: '',
        name: 'drafts_index',
        component: DraftsIndexView,
        meta: {
          permissions: ['administrator', 'agent', 'custom_role'],
        },
      },
      {
        path: ':id/compose',
        name: 'drafts_compose',
        component: DraftsComposeView,
        meta: {
          permissions: ['administrator', 'agent', 'custom_role'],
        },
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/scheduled'),
    component: DraftsWrapper,
    props: {
      headerTitle: '',
      icon: '',
      showNewButton: false,
    },
    children: [
      {
        path: '',
        name: 'scheduled_index',
        component: ScheduledIndexView,
        meta: {
          permissions: ['administrator', 'agent', 'custom_role'],
        },
      },
      {
        path: ':id/compose',
        name: 'scheduled_compose',
        component: DraftsComposeView,
        meta: {
          permissions: ['administrator', 'agent', 'custom_role'],
        },
      },
    ],
  },
];
